import * as React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { LandingPage } from '../components/landing/LandingPage';
import { AuthCallback } from '../components/auth/AuthCallback';
import { AuthSignup } from '../components/auth/AuthSignup';
import { AppEntryPoint } from '../components/app/AppEntryPoint';
import { ProfilePage } from '../pages/ProfilePage';
import { AdminPage } from '../pages/AdminPage';
import { SubscriptionPage } from '../pages/SubscriptionPage';
import { SuccessPage } from '../pages/SuccessPage';
import { PublicRoute } from './PublicRoute';
import { PrivateRoute } from './PrivateRoute';
import { MainRoute } from './MainRoute';
import { logger } from '../utils/logger';

export function AppRoutes() {
  const location = useLocation();

  // Log current route for debugging
  React.useEffect(() => {
    logger.component('🧭 AppRoutes: Current route', {
      pathname: location.pathname,
      search: location.search,
      timestamp: new Date().toISOString(),
    });
  }, [location.pathname, location.search]);

  return (
    <Routes>
      {/* Public routes wrapped in PublicRoute */}
      <Route element={<PublicRoute />}>
        <Route path="/" element={<LandingPage />} />
      </Route>
      
      {/* Auth routes - render directly without auth checks */}
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/signup" element={<AuthSignup />} />
      
      {/* App entry point - handles smart redirect */}
      <Route
        path="/app"
        element={
          <PrivateRoute>
            <AppEntryPoint />
          </PrivateRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <MainRoute />
          </PrivateRoute>
        }
      />
      <Route
        path="/project"
        element={
          <PrivateRoute>
            <MainRoute />
          </PrivateRoute>
        }
      />
      <Route
        path="/project/:projectId"
        element={
          <PrivateRoute>
            <MainRoute />
          </PrivateRoute>
        }
      />
      <Route
        path="/project/:projectId/topic/:topicId"
        element={
          <PrivateRoute>
            <MainRoute />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <PrivateRoute adminOnly={true}>
            <AdminPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/subscription"
        element={
          <PrivateRoute>
            <SubscriptionPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/success"
        element={
          <PrivateRoute>
            <SuccessPage />
          </PrivateRoute>
        }
      />

      {/* Debug component for unmatched routes */}
      <Route
        path="*"
        element={
          <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 text-white">
            <h1 className="text-2xl font-bold mb-4">Page Not Found</h1>
            <p className="text-lg mb-8">Path: {location.pathname}</p>
            <button
              onClick={() => (window.location.href = '/')}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Go to Home
            </button>
          </div>
        }
      />
    </Routes>
  );
}

export default AppRoutes;
